module.exports = __webpack_public_path__ + "HarshitAdepu-4ce2673b.webp";